import { appApi } from '@web/app/store/api'
import { IChangePasswordRequest, IChangePasswordResponse, IProfileResponse } from '../types'

export const profileApi = appApi.injectEndpoints({
  endpoints: (builder) => ({

    changePassword: builder.mutation<IChangePasswordResponse, IChangePasswordRequest>({
      query: (body) => ({
        url: '/api/v1/users/change-password',
        method: 'POST',
        body,
      }),
      // "Invalida" el perfil, forzando un refresco automático
      invalidatesTags: ['Profile'], 
    }),

    getProfile: builder.query<IProfileResponse, void>({
      query: () => ({
        url: '/api/v1/users/profile',
        method: 'GET',
      }),
      // "Provee" el tag para que el sistema sepa qué refrescar
      providesTags: ['Profile'],
      keepUnusedDataFor: 0,
    })
  }),
  overrideExisting: false,
})

export const { useChangePasswordMutation, useGetProfileQuery } = profileApi